// import React from "react";
import { Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CommonPage from "../NCLLayout";
import DownloadStudentResponses from "../../NCLAdmin/StudentResponses";
import OMRUPloadfile from "../../NCLAdmin/OMRAnswers/UPloadFile";

import QBReports from "../../NCLAdmin/QBReports";

import Assessments from "../../NCLAdmin/WeeklySodhanaTests/Assessments";
import WeeklyTests from "../../NCLAdmin/WeeklySodhanaTests/WeeklyTests";
import AddTest from "../../NCLAdmin/WeeklySodhanaTests/AddWeeklyTests";
import PreviewQuestionPaper from "../../NCLAdmin/WeeklySodhanaTests/PreviewQuestionPaper";
import Schools from "../../NCLAdmin/Masters/Schools";
import AddSchool from "../../NCLAdmin/Masters/AddSchool";

import AssessmentParticipationReport from "../../NCLAdmin/AssessmentParticipation/AssessmentParticipationReport";
import OverallWeeklyQuestions from "../../NCLAdmin/QBReports/OverallWeeklyQuestions";
import QuestionStatusTrack from "../../NCLAdmin/QBReports/QuestionStatusTrack";
import AssessmentQuestionPaper from "../../NCLAdmin/WeeklySodhanaTests/AssessmentQuestionPaper";

import InstituteHierarchy from "../../NCLAdmin/Institutes/InstituteHierarchy";
import Institution from "../../NCLAdmin/Institutes/Institution";
import QBAdminLogin from "../../NCLAdmin/QBAdminLogin/QBAdminLogin";
import Parameters from "../../NCLAdmin/Parameters/AssessmentParameters";

import RWNES from "../../NCLAdmin/RWNElectiveSubject/RWNES";

import DownloadDetails from "../../NCLAdmin/Logdetails";

import PPTFilters from "../../NCLAdmin/PPTGeneration/PPTFilters";

import PTReports from "../../NCLAdmin/PracticeTestReports/PTReports";
import StudentDeactivation from "../../NCLAdmin/StudentsDeactivation/StudentDeactivation";

import Studentdetails from "../../Teacher/Registration/StudentDetails";
const NCLAdminRoutes = (items) => {

    return (
        <>
            <Route path="/NCLAdmin" element={!!items ? <CommonPage /> : <Navigate replace to="/login" />} >

                <Route path="/NCLAdmin/StudentResponses" element={<DownloadStudentResponses />} />
                <Route path="/NCLAdmin/QBAdminLogin/QBAdminLogin" element={<QBAdminLogin />} />
                <Route path="/NCLAdmin/Assessments">
                    <Route index element={<Assessments />} />
                    <Route path="/NCLAdmin/Assessments/AddTest" element={<AddTest />} />
                    <Route path="/NCLAdmin/Assessments/AssessmentQuestionPaper" element={<AssessmentQuestionPaper />} />
                    <Route path="/NCLAdmin/Assessments/WeeklyTests" element={<WeeklyTests />} />
                    <Route path="/NCLAdmin/Assessments/PreviewQuestionPaper" element={<PreviewQuestionPaper />} />
                </Route>
                <Route path="InstitutionMaster">
                    <Route index element={<Institution />} />
                    <Route path="/NCLAdmin/InstitutionMaster/InstituteHierarchy" element={<InstituteHierarchy />} />
                </Route>
                <Route path="/NCLAdmin/Schools">
                    <Route index element={<Schools />} />
                    <Route path="/NCLAdmin/Schools/AddSchool" element={<AddSchool />} />
                    <Route path="/NCLAdmin/Schools/StudentDetails" element={<Studentdetails />} />
                </Route>
                <Route path="/NCLAdmin/AssessmentParticipation/AssessmentParticipationReport" element={<AssessmentParticipationReport />} />
                <Route path="/NCLAdmin/QBReports" element={<QBReports />}>
                    <Route path="/NCLAdmin/QBReports/WeeklyOverallQuestions" element={<OverallWeeklyQuestions />} />
                    <Route path="/NCLAdmin/QBReports/QuestionStatusTrack" element={<QuestionStatusTrack />} />
                </Route>
                <Route path="/NCLAdmin/Parameters/AssessmentParameters">
                    <Route index element={<Parameters />} />
                </Route>
                  <Route path="StudentsDeactivation" element={<StudentDeactivation />}/>
                
            </Route>
            <Route path="/OMRResults" element={<CommonPage />}>
                <Route index element={<OMRUPloadfile />} />
            </Route>
            <Route path="/RWNOELective" element={<CommonPage />}>
                <Route index element={<RWNES />} />
            </Route>
            <Route path="/DownloadDetails" element={<CommonPage />}>
                <Route index element={<DownloadDetails />} />
            </Route>

            <Route path="/GeneratePPT" element={<CommonPage />}>
                <Route index element={<PPTFilters />} />
            </Route>
            <Route path="/Practice Test Reports" element={<CommonPage />}>
                <Route index element={<PTReports />} />
            </Route>
            
        </>
    )
}
export default NCLAdminRoutes;